const Setup = {
  primaryColor: "#013757",
  linkColor: "white",
};

export default Setup;
